{
  "All": "All",
  "Almost there...": "Almost there...",
  "Approved By": "Approved By",
  "Cancel": "Cancel",
  "Created By": "Created By",
  "Current Month": "Current Month",
  "Date of Writeback": "Date of Writeback",
  "Insurance Information": "Insurance Information",
  "Insurance Writeback Log": "Insurance Writeback Log",
  "Last Month": "Last Month",
  "Old information": "Old information",
  "One second...": "One second...",
  "Patient ID": "Patient ID",
  "Person": "Person",
  "Reason": "Reason",
  "Retry Writeback": "Retry Writeback",
  "Retry writeback": "Retry writeback",
  "Search for a name...": "Search for a name...",
  "Select Source": "Select Source",
  "Select Source ID": "Select Source ID",
  "Something went wrong during writeback process. Please try again.": "Something went wrong during writeback process. Please try again.",
  "Status": "Status",
  "Synced By": "Synced By",
  "The insurance information below will be written back to the PMS": "The insurance information below will be written back to the PMS",
  "Time of writeback": "Time of writeback",
  "Today": "Today",
  "Updated By": "Updated By",
  "Updated information": "Updated information",
  "User": "User",
  "View past insurance writeback actions to verify that all the information was submitted correctly. Click on a row to view historical writeback details for a patient.": "View past insurance writeback actions to verify that all the information was submitted correctly. Click on a row to view historical writeback details for a patient.",
  "We're still working on it...": "We're still working on it...",
  "Writeback Successful. The updated data will be available in your PMS soon.": "Writeback Successful. The updated data will be available in your PMS soon.",
  "Yesterday": "Yesterday"
}
